import { render, staticRenderFns } from "./zuijinKs.vue?vue&type=template&id=6cfa189c&scoped=true"
import script from "./zuijinKs.vue?vue&type=script&lang=js"
export * from "./zuijinKs.vue?vue&type=script&lang=js"
import style0 from "./zuijinKs.vue?vue&type=style&index=0&id=6cfa189c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfa189c",
  null
  
)

export default component.exports